<template>
  <div class="border-box-3" :ref="ref">
    <svg class="border-svg-container" :width="width" :height="height" viewBox="0 0 1164 56">
      <defs>
        <linearGradient id="grad3" x1="0.5" y1="1" x2="0.5" y2="0.0002">
          <stop offset="0.5" :stop-color="mergedColor[0]" stop-opacity="0"/>
          <stop offset="1" :stop-color="mergedColor[0]" stop-opacity="0.2"/>
        </linearGradient>
      </defs>
      <path :d="`M580,95 c-479.666-.248-960,0.5-960,0.5l40-22.808h158l91-2.973s84.833,2.643,157-13.878c0,0,22-6.525,38-13.877,0,0,37-24.721,68-29.656,0,0,82.5-10.82,209-9,0,0,149.784-.126,199-0.171m0,91.675c479.669-.246,960,0.5,960,0.5l-40-22.739H1332l-71-2.962s-114.83,2.657-187-13.8c0,0-22-6.5-38-13.821,0,0-37-24.621-68-29.535,0,0-82.5-10.776-209-8.966 l-179-.17`"
            fill="url(#grad3)"
            fill-rule="evenodd"/>
      <path :d="`M580,105 c-479.666-.248-960,0.5-960,0.5l40-22.808h158l91-2.973s84.833,2.643,157-13.878c0,0,22-6.525,38-13.877,0,0,37-24.721,68-29.656,0,0,82.5-10.82,209-9,0,0,149.784-.126,199-0.171m0,91.675c479.669-.246,960,0.5,960,0.5l-40-22.739H1332l-71-2.962s-114.83,2.657-187-13.8c0,0-22-6.5-38-13.821,0,0-37-24.621-68-29.535,0,0-82.5-10.776-209-8.966 l-179-.17`"
            :stroke="mergedColor[1]" stroke-width="2px" fill-rule="evenodd" opacity="0.16" :fill="backgroundColor"/>
    </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'
export default {
  name: 'BorderBox3',
  mixins: [autoResize],
  props: {
    color:{
      type:Array,
      default:()=>([])
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data() {
    return {
      ref:'border-box-2',
      defaultColor: ['#00d4ff','#2cf7fe'],
      mergedColor: []
    }
  },
  methods: {
    mergeColor() {
      const {color, defaultColor} = this
      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted() {
    const {mergeColor}=this
    mergeColor()
  }
}
</script>

<style lang="less">
  .border-box-3{
    position: relative;
    width: 100%;
    height: 100%;

    .border-svg-container{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    }
    .border-box-content{
      position: relative;
      width: 100%;
      height: 100%;
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-3/main.vue